import { render, staticRenderFns } from "./BrokerCaseOverview.vue?vue&type=template&id=08ca1154"
import script from "./BrokerCaseOverview.vue?vue&type=script&lang=js"
export * from "./BrokerCaseOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports